import { useState, useRef, useEffect } from "react";
import { HelpCircle } from "lucide-react";

// Small reusable "?" help bubble for the Admin.
// Desktop: hover or click. Mobile/tablet: tap. Keep explanations short & in French.
export const HelpTip = ({ text, className = "" }) => {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    if (!open) return;
    const onDoc = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", onDoc);
    return () => document.removeEventListener("mousedown", onDoc);
  }, [open]);

  if (!text) return null;
  return (
    <span ref={ref} className={`relative inline-flex ${className}`}>
      <button type="button" aria-label="Aide"
        onClick={(e) => { e.preventDefault(); e.stopPropagation(); setOpen((o) => !o); }}
        onMouseEnter={() => setOpen(true)} onMouseLeave={() => setOpen(false)}
        className="text-secondary2/70 hover:text-electric transition-colors align-middle" data-testid="help-tip-btn">
        <HelpCircle size={13} />
      </button>
      {open && (
        <span role="tooltip" data-testid="help-tip-bubble"
          className="absolute left-1/2 bottom-full mb-2 -translate-x-1/2 z-[60] w-56 rounded-lg border border-electric/30 bg-[#121212] px-3 py-2 text-[11px] leading-relaxed text-white/90 shadow-xl normal-case tracking-normal">
          {text}
        </span>
      )}
    </span>
  );
};
